import { render, staticRenderFns } from "./DirectorRelationship.vue?vue&type=template&id=6230dd93&"
import script from "./DirectorRelationship.vue?vue&type=script&lang=js&"
export * from "./DirectorRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports